import { faBadgeCheck } from '@fortawesome/pro-solid-svg-icons'
import { Flex, Text, Tooltip } from '@mantine/core'

import { useTranslation } from '@flecto/translations'
import { type ParameterID, type CoreBookingDocument } from '@flecto/types'
import { Icon, useModal } from '@flecto/ui'

import { useBookingDocumentCategories } from '../../hooks/useBookingDocumentCategories'
import { ModalViewSingleDocument } from '../ModalViewSingleDocument/ModalViewSingleDocument'
import styles from './styles.module.css'

type DocumentBoxItemProps = {
  document: CoreBookingDocument
  id: ParameterID
}

export const DocumentBoxItem = ({ document, id }: DocumentBoxItemProps) => {
  const { t } = useTranslation('saas', { keyPrefix: 'booking' })
  const { openModal } = useModal(
    <ModalViewSingleDocument id={id} documentId={document.id} />
  )
  const { getCategory } = useBookingDocumentCategories()
  const doc = getCategory(document.category)
  return (
    <Flex
      columnGap='sm'
      wrap='nowrap'
      align='center'
      justify='flex-start'
      mb='sm'
      onClick={() => openModal()}
      className={styles.documentItem}
    >
      {doc?.icon && (
        <Icon
          icon={doc?.icon}
          size='xs'
          color={doc.color}
          withCircleBackground
          style={{ flexShrink: 0 }}
        />
      )}
      <Text fw='500' truncate>
        {document.generated ? document.filename_base : document.filename}
      </Text>

      {document?.signed && (
        <Tooltip
          label={t('booking_documents.tooltip_icon_signed')}
          zIndex={11000}
          withinPortal
        >
          <Text>
            <Icon icon={faBadgeCheck} color='gray.6' />
          </Text>
        </Tooltip>
      )}
    </Flex>
  )
}
